<template>
    <div class="footer">
        <div class="content">
            <p>Não perca essa oportunidade! Receba uma proposta de antecipação de recebíveis ainda hoje!</p>
            <a @click="$emit('openModal')">Solicitar Proposta</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer'
};
</script>

<style lang="scss" scoped>
.footer {
    background: #007bff;
    padding: 72px 16px;
    .content {
        max-width: 1120px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 50px;
        @media screen and (max-width: 768px) {
            flex-direction: column;
            text-align: center;
        }
        p {
            color: #fff;
            font-family: 'Open Sans', sans-serif;
            font-size: 20px;
            line-height: 30px;
            margin: 0;
            font-weight: 400;
        }
        a {
            background: #fdc30c;
            font-family: 'Open Sans', sans-serif;
            border-radius: 4px;
            font-weight: 700;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            text-transform: uppercase;
            color: #000;
            padding: 15px 30px;
            display: inline-block;
            cursor: pointer;
            width: 50%;
            @media screen and (max-width: 768px) {
                width: 100%;
            }
        }
    }
}
</style>
